import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl';
import { HomeThirdSection } from '../Home/components/HomeThirdSection';
import { pathFromRoute } from '../../../utils/helpers/acl/pathFromRoute';
import { Route } from '../../../config/acl/routes/Route';
import { metricsGoals } from '../../../utils/constans/metrics/goals';
import { FONTS } from '../../../utils/constans/styles/fonts';
import { mediaScreenSizes } from '../../../utils/constans/styles/screenSizes';

const PageStyled = styled.div`
  height: 100%;
  width: 100%;
  background: #F3F5F7;
  padding-top: 24px;
`;

const SignUpButtonWrapper = styled.div`
  padding: 24px;
  max-width: 1260px;
  margin: 0 auto;
  box-sizing: border-box;
`;

const SignUpButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 330px;
  padding: 18px 24px;
  font-family: ${FONTS.TEXT_REGULAR_INTER};
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  color: #F7F3F0;
  background: #1890FF;
  border: none;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 57, 152, 0.25);
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.1s ease;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;

  :hover {
    opacity: 0.9;
  }
  :active {
    transform: scale(0.98);
  }

  @media (max-width: ${mediaScreenSizes.mobile}) {
    max-width: none;
  }
`;

const Messages = defineMessages({
  signUp: { id: 'forBrokersPage.signUp', defaultMessage: 'Sign up' },
});

export const ForBrokersPage: React.FC = () => {
  const navigate = useNavigate();
  const intl = useIntl();

  const onSignUp = () => {
    metricsGoals.openRegisterPageAfterVisitHome();
    navigate(pathFromRoute(Route.register));
  };

  return (
    <PageStyled>
      <HomeThirdSection />
      <SignUpButtonWrapper>
        <SignUpButton onClick={onSignUp}>
          {intl.formatMessage(Messages.signUp)}
        </SignUpButton>
      </SignUpButtonWrapper>
    </PageStyled>
  );
};
